import { Dropdown } from "components/Dropdown/Dropdown";
import Form from "components/react-validation/components/form";
import Input from "components/react-validation/components/input";
import Submit from "components/react-validation/components/submit";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import { AppSettings } from "../../constants";
import * as Vali from "../../helper/validator-helper";
import * as UserActionType from "../constants";
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
// import './invite-user.scss';

console.log("Apppseitng role", AppSettings);
const roleOptions =
  (AppSettings.ROLES &&
    AppSettings.ROLES.map((key) => {
      // if(AppSettings.clientTypeValue === 'System'){
      //   return {
      //     text: AppSettings.LIST_ROLES.find(t => t.key === key.key).value,
      //     value: key
      //   };
      // }else{
      return {
        text: AppSettings.LIST_ROLES.find((t) => t.key === key).value,
        value: key,
      };
      // }
    })) ||
  [];

export class InviteNonSystemUser extends Component {
  static propTypes = {
    userProfile: PropTypes.object,
    isHidden: PropTypes.bool,
    onSave: PropTypes.func,
    onBack: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedRole: roleOptions[0],
      isCloseRestrict:false
    };
  }

  onSelectRole = (e) => {
    this.setState({ selectedRole: e.value });
  };

  onSubmit = (e) => {
    e.preventDefault();
    let data = this.form.getValues();
    data["roleName"] = this.state.selectedRole.value;
    data['restrictWOCloseOption'] = this.state.isCloseRestrict;
    this.props.onSave(e, data, UserActionType.INVITE_USER_NON_SYSTEM_ASYNC);
  };
  onCheckCloseRestrict = () => {
    console.log('this.state.selectedRole',this.state.selectedRole)
    this.setState({
      isCloseRestrict: !this.state.isCloseRestrict,
    });
  };
  render() {
    return (
      !this.props.isHidden && (
        <div className={this.props.isHidden ? "cls-hidden" : ""}>
          <Form
            ref={(c) => {
              this.form = c;
            }}
            onSubmit={this.onSubmit}
          >
            <div className="box-form-body">
              <Row>
                <Col md={6} sm={6}>
                  <p className="description">
                    Please enter additional information for{" "}
                    <span className="cls-bold">
                      {this.props.userProfile.email}
                    </span>
                  </p>
                  <Input
                    type="hidden"
                    name="redirectUrl"
                    value={AppSettings.REDIRECT_URL_INVITE}
                  />
                  <Input
                    type="hidden"
                    name="email"
                    value={this.props.userProfile.email}
                  />
                  <div className="form-group">
                    <label>
                      First name <span className="text-danger">*</span>
                    </label>
                    <Input
                      type="text"
                      name="firstName"
                      ref="firstName"
                      // value={this.props.userProfile.firstName}
                      placeholder="First name"
                      // autocomplete='off'
                      autoFocus
                      className="form-control"
                      maxLength="40"
                      max="40"
                      validations={[Vali.required, Vali.maxlength]}
                    />
                  </div>

                  <div className="form-group">
                    <label>
                      Last name <span className="text-danger">*</span>
                    </label>
                    <Input
                      type="text"
                      name="lastName"
                      ref="lastName"
                      // value={this.props.userProfile.lastName}
                      placeholder="Last name"
                      className="form-control"
                      maxLength="40"
                      max="40"
                      validations={[Vali.required, Vali.maxlength]}
                    />
                  </div>

                  <div className="form-group">
                    <label>
                      Role <span className="text-danger">*</span>
                    </label>
                    <Dropdown
                      onChange={this.onSelectRole}
                      className="filestring-dropdown filter-dropdown"
                      options={roleOptions}
                      optionLabel="text"
                      value={this.state.selectedRole}
                      name="role"
                      placeholder="-- Please select"
                      style={{ width: "100%" }}
                    />
                  </div>
                  {this.state.selectedRole.value === 'BuilderUser'&&
                  <CheckBoxSingle
                    checked={this.state.isCloseRestrict}
                    onChecked={this.onCheckCloseRestrict}
                    ref={(c) => {
                    this.check = c;
                    }}
                    label='Enable "Close Work Order" option'
                    className='checkbox-default'
                    style={{ marginLeft: '5px' }}
                    name='isRestrictClose'
                    />
                  }
                  <div className="form-group">
                    <a
                      className="btn btn-primary margin-right-5 btn-siteone-default"
                      onClick={(e) => {
                        this.props.onBack(e);
                      }}
                    >
                      <i className="glyphicon glyphicon-menu-left" /> Back
                    </a>
                    <Submit className="btn btn-primary btn-siteone">
                      Invite
                    </Submit>
                  
                  </div>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/User/Components/invite-nonsystem-user.js